import { Vue } from 'vue-property-decorator'

export const serviceTypeStatus = () => {
  return {
    FINAL_DESTINATION: { key: 20040001, label: Vue.prototype.$gettext('SERVICE_TYPE.20040001') },
    WASTE_COLLECTION: { key: 20040002, label: Vue.prototype.$gettext('SERVICE_TYPE.20040002') },
    VALORIZATION: { key: 20040003, label: Vue.prototype.$gettext('SERVICE_TYPE.20040003') },
    ETE: { key: 20040004, label: Vue.prototype.$gettext('SERVICE_TYPE.20040004') },
    AUTOCLAVE: { key: 20040005, label: Vue.prototype.$gettext('SERVICE_TYPE.20040005') },
    RCC: { key: 20040006, label: Vue.prototype.$gettext('SERVICE_TYPE.20040006') },
    FREIGHT: { key: 20040007, label: Vue.prototype.$gettext('SERVICE_TYPE.20040007') },
    CONTRACT_MAINTENANCE: { key: 20040008, label: Vue.prototype.$gettext('SERVICE_TYPE.20040008') },
    RECEIPT_VALORIZATION: { key: 20040009, label: Vue.prototype.$gettext('SERVICE_TYPE.20040009') },
    WEIGHING_SERVICE: { key: 20040010, label: Vue.prototype.$gettext('SERVICE_TYPE.20040010') },
    TWM_SERVICE: { key: 20040011, label: Vue.prototype.$gettext('SERVICE_TYPE.20040011') },
    HORIZONTAL_BALING_PRESS: { key: 20040012, label: Vue.prototype.$gettext('SERVICE_TYPE.20040012') },
    WEIGHING_AND_TRACEABILITY_PROJECT: { key: 20040013, label: Vue.prototype.$gettext('SERVICE_TYPE.20040013') },
    EFFLUENT_WATER_TREATMENT: { key: 20040014, label: Vue.prototype.$gettext('SERVICE_TYPE.20040014') },
    FREIGHT_APPORTIONMENT: { key: 20040015, label: Vue.prototype.$gettext('SERVICE_TYPE.20040015') }
  }
}
